const inputs = {
  
  ansibleRunerPath: {
    id: 'ansible_runer_path',
    name: 'ansibleRunerPath',
    input: 'textField',
    label: 'configuration.form.ansibleRunerPath.label',
    placeholder: 'configuration.form.ansibleRunerPath.placeholder',
    rules: {
      required: { value: true },
    },
  },
  ansibleConfig: {
    id: 'ansible_config',
    name: 'ansibleConfig',
    input: 'textField',
    label: 'configuration.form.ansibleConfig.label',
    placeholder: 'configuration.form.ansibleConfig.placeholder',
    rules: {
      required: { value: true },
    },
  },
  mailHost: {
    id: 'mail_host',
    name: 'mailHost',
    input: 'textField',
    label: 'configuration.form.mailHost.label',
    placeholder: 'configuration.form.mailHost.placeholder',
    rules: {
      required: { value: true },
    }
  },
  mailPort: {
    id: 'mail_port',
    name: 'mailPort',
    type: 'number',
    input: 'textField',
    label: 'configuration.form.mailPort.label',
    placeholder: 'configuration.form.mailPort.placeholder',
    rules: {
      required: { value: true },
    },
  },
  mailSecure: {
    id: 'mail_secure',
    name: 'mailSecure',
    input: 'switch',
    label: 'configuration.form.mailSecure.label',
    placeholder: 'configuration.form.mailSecure.placeholder',
    rules: {
      required: { value: true },
    },    
  },
  mailUser: {
    id: 'mail_user',
    name: 'mailUser',
    input: 'textField',
    label: 'configuration.form.mailUser.label',
    placeholder: 'configuration.form.mailUser.placeholder',
    rules: {
      required: { value: true },
    },    
  },
  mailPass: {
    id: 'mail_pass',
    name: 'mailPass',
    input: 'textField',
    type: 'password',
    label: 'configuration.form.mailPass.label',
    placeholder: 'configuration.form.mailPass.placeholder',
    rules: {
      required: { value: true },
    },    
  },
  mailRejectUnauthorized: {
    id: 'mail_rejectUnauthorized',
    name: 'mailRejectUnauthorized',
    input: 'switch',
    label: 'configuration.form.mailRejectUnauthorized.label',
    placeholder: 'configuration.form.mailRejectUnauthorized.placeholder',
    rules: {
      required: { value: true },
    },    
  },
  mailFrom: {
    id: 'mail_from',
    name: 'mailFrom',
    input: 'textField',
    label: 'configuration.form.mailFrom.label',
    placeholder: 'configuration.form.mailFrom.placeholder',
    rules: {
      required: { value: true },
    },    
  },
  threads: {
    id: 'threads',
    name: 'threads',
    input: 'textField',
    label: 'configuration.form.threads.label',
    placeholder: 'configuration.form.threads.placeholder',
    rules: {
      required: { value: true },
    },
  },
  inventory_path: {
    id: 'inventory_path',
    name: 'inventory_path',
    input: 'textField',
    label: 'configuration.form.inventoryPath.label',
    placeholder: 'configuration.form.inventoryPath.placeholder',
    rules: {
      required: { value: true },
    },
  },
  macros_playbook_path: {
    id: 'macros_playbook_path',
    name: 'macros_playbook_path',
    input: 'textField',
    label: 'configuration.form.macrosPlaybookPath.label',
    placeholder: 'configuration.form.macrosPlaybookPath.placeholder',
    rules: {
      required: { value: true },
    },
  },
  macros_playbook: {
    id: 'macros_playbook',
    name: 'macros_playbook',
    input: 'textField',
    label: 'configuration.form.macrosPlaybook.label',
    placeholder: 'configuration.form.macrosPlaybook.placeholder',
    rules: {
      required: { value: true },
    },
  },
  macros_config_path: {
    id: 'macros_config_path',
    name: 'macros_config_path',
    input: 'textField',
    label: 'configuration.form.macrosConfigPath.label',
    placeholder: 'configuration.form.macrosConfigPath.placeholder',
    rules: {
      required: { value: true },
    },
  },
  
}

export default inputs;